import React from 'react';

const Card = ({ className, children }) => (
  <div
    className={`p-8 rounded-xl border border-solid border-gray-200 ${className}`}
    style={{
      boxShadow: '0 10px 28px rgba(0,0,0,.08)',
      backdropFilter: 'blur(10px)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)'
    }}
  >
    {children}
  </div>
);

export default Card;
